module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Medium-aa1e7631641df3d58a2c90588889d8ef.ttf";